import { SAMPLE_SOCIAL_NETWORKS } from "@/common/lib/onboarding-preview-samples";

const state = {
    onboardingFlow: null,
    businessType: "",
    completedSteps: [],
    selections: {},
    // Arranca con forma vacia, no `null`: las paginas leen `onboardingDraft.*`
    // directo en el template, y el primer render de Vue ocurre antes de que
    // el `mounted()` (async) llegue a hidratarlo con HYDRATE_DRAFT.
    // `socialNetworks` arranca con la muestra generica (no vacio): mientras
    // el usuario no ha elegido ninguna red todavia, el preview igual debe
    // mostrar algo de ejemplo, no quedar sin iconos.
    onboardingDraft: {
        logoIconUrl: "",
        stackColors: {},
        businessDescription: "",
        socialNetworks: [...SAMPLE_SOCIAL_NETWORKS],
        whatsappNumber: "",
        customLinks: [],
        products: [],
        displayMode: "catalog"
    },
    // Flag interno para que HYDRATE_DRAFT sepa si ya corrio en esta sesion
    // (el draft ya no es un buen indicador: nunca es null).
    onboardingDraftHydrated: false,
    stepperUi: {
        nextDisabled: false,
        loading: false,
        nextLabel: "",
        nextVariant: "primary"
    },
    requestNextToken: 0
};

export default state;
